function productCardSlider() {
    if (window.innerWidth <= 1023) {
        const sliders = document.querySelectorAll('.product-card__slider');

        sliders.forEach(slider => {
            if (slider.swiper) return;

            new Swiper(slider, {
                enabled: true,
                slidesPerView: 1,
                loop: true,
                nested: true,
                pagination: {
                    el: '.product-card__slider-pagination',
                },
            });
        })
    } else {
        let productCardSliderItem = $('.product-card__slider-item:not(.init)');

        productCardSliderItem.addClass('init')

        productCardSliderItem.hover((e) => {
            let parentSlider = $(e.target).parents('.product-card__slider');
            let numberSliderHover = parentSlider.find(productCardSliderItem).index(e.target);
            let parentSliderDots = parentSlider.find('.product-card__slider-dots-item');
            $(parentSliderDots.get(numberSliderHover)).addClass('product-card__slider-dots-item--active');
            $(parentSliderDots.get(numberSliderHover)).siblings().removeClass('product-card__slider-dots-item--active');
        })
        productCardSliderItem.mouseout((e) => {
            let parentSlider =  $(e.currentTarget).parents('.product-card__slider');
            parentSlider
                .find('.product-card__slider-dots-item--active')
                .removeClass('product-card__slider-dots-item--active');
            parentSlider
                .find('.product-card__slider-dots-item')
                .first()
                .addClass('product-card__slider-dots-item--active');
        });

        document.querySelectorAll('.product-card__slider-dots').forEach(item => {
            const slider = item.closest('.swiper');
            const slides = slider.querySelectorAll('.swiper-slide');

            if (slides.length > 0) {
                item.innerHTML = `
                    <span class="product-card__slider-dots-item product-card__slider-dots-item--active"></span>
                    ${'<span class="product-card__slider-dots-item"></span>'.repeat(slides.length - 1)}
                `
            } else {
                item.innerHTML = '';
            }
        })
        $('.product-card__slider-content').css('transform', 'none');
        $('.product-card__slider-dots-item--active').removeClass('product-card__slider-dots-item--active');
        $('.product-card__slider .product-card__slider-dots').find(">:first-child").addClass('product-card__slider-dots-item--active');
    }
}
